<div class="h-full w-full flex flex-col overflow-hidden">

    @if (isProcessing()) {
    <div class="flex flex-col items-center justify-center h-full gap-3 text-gray-400">
        <app-icon [type]="'loader-circle'" [source]="'lucide'" [size]="'xl'" class="animate-spin" />
        <span class="text-sm">Loading vendor analysis data…</span>
    </div>
    }

    @else if (isEmpty()) {
    <div class="flex flex-col items-center justify-center h-full gap-3 text-gray-400">
        <app-icon [type]="'user-round-search'" [source]="'lucide'" [size]="'xl'" />
        <span class="text-sm">No vendor analysis data available</span>
    </div>
    }

    @else {
    <div class="flex flex-col h-full p-3 gap-3 overflow-y-auto">
        <div class="">
            <div class="flex justify-between items-center mb-3 ml-1">
                <h3 class="text-md font-semibold">Project Information</h3>
                <div class="flex items-center gap-1">
                    <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'" variant="outlined"
                        severity="contrast" pTooltip="Expand" tooltipPosition="top"
                        (clicked)="openExpandDialog('projectInfo')">
                    </app-button>
                    <app-button [icon]="'pencil'" [iconSource]="'lucide'" [size]="'default'" variant="outlined"
                        severity="contrast" pTooltip="Edit" tooltipPosition="top" (clicked)="openProjectInfoEdit()">
                    </app-button>
                </div>
            </div>
            <app-data-table [data]="projectInfoRows()" [columns]="projectInfoColumns" [config]="tableConfig"
                dataKey="property" [customTemplates]="projectInfoCustomTemplates" />
        </div>

        <div class="">
            <div class="flex justify-between items-center mb-3 ml-1">
                <h3 class="text-md font-semibold">Works</h3>
                <app-button [icon]="'pencil'" [iconSource]="'lucide'" [size]="'default'" variant="outlined"
                    severity="contrast" pTooltip="Edit" tooltipPosition="top" (clicked)="openExcelSheet('Works')">
                </app-button>
            </div>

            <div class="flex flex-col gap-4">

                <div>
                    <div class="flex justify-between items-center mb-2 ml-1">
                        <h4 class="text-sm font-semibold">General Works</h4>
                        <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'" variant="outlined"
                            severity="contrast" pTooltip="Expand" tooltipPosition="top"
                            (clicked)="openExpandDialog('generalWorks')">
                        </app-button>
                    </div>
                    <app-data-table [data]="generalWorks()" [columns]="worksColumns" [config]="tableConfig"
                        dataKey="name" [customTemplates]="worksCustomTemplates" />
                </div>

                <div>
                    <div class="flex justify-between items-center mb-2 ml-1">
                        <h4 class="text-sm font-semibold">Stabilization Works</h4>
                        <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'" variant="outlined"
                            severity="contrast" pTooltip="Expand" tooltipPosition="top"
                            (clicked)="openExpandDialog('stabilizationWorks')">
                        </app-button>
                    </div>
                    <app-data-table [data]="stabilizationWorks()" [columns]="worksColumns" [config]="tableConfig"
                        dataKey="name" [customTemplates]="worksCustomTemplates" />
                </div>

            </div>
        </div>

        <div class="">
            <div class="flex justify-between items-center mb-3 ml-1">
                <h3 class="text-md font-semibold">Work Costs</h3>
                <app-button [icon]="'pencil'" [iconSource]="'lucide'" [size]="'default'" variant="outlined"
                    severity="contrast" pTooltip="Edit" tooltipPosition="top"
                    (clicked)="openExcelSheet('Cost Estimation')">
                </app-button>
            </div>

            <div class="flex flex-col gap-6">


                <div class="flex flex-col gap-4">
                    <h4 class="text-sm font-semibold ml-1">General Work Costs</h4>

                    <div>
                        <div class="flex justify-between items-center mb-2 ml-1">
                            <h5 class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Materials</h5>
                            <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'"
                                variant="outlined" severity="contrast" pTooltip="Expand" tooltipPosition="top"
                                (clicked)="openExpandDialog('generalMaterials')">
                            </app-button>
                        </div>
                        <app-data-table [data]="generalWorkCostFlat().materials" [columns]="materialsColumns"
                            [config]="materialsTableConfig" dataKey="workName"
                            [customTemplates]="materialsCustomTemplates" />
                    </div>

                    <div>
                        <div class="flex justify-between items-center mb-2 ml-1">
                            <h5 class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Labour</h5>
                            <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'"
                                variant="outlined" severity="contrast" pTooltip="Expand" tooltipPosition="top"
                                (clicked)="openExpandDialog('generalLabour')">
                            </app-button>
                        </div>
                        <app-data-table [data]="generalWorkCostFlat().labours" [columns]="laboursColumns"
                            [config]="tableConfig" dataKey="workName" [customTemplates]="laboursCustomTemplates" />
                    </div>

                    <div>
                        <div class="flex justify-between items-center mb-2 ml-1">
                            <h5 class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Equipment</h5>
                            <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'"
                                variant="outlined" severity="contrast" pTooltip="Expand" tooltipPosition="top"
                                (clicked)="openExpandDialog('generalEquipment')">
                            </app-button>
                        </div>
                        <app-data-table [data]="generalWorkCostFlat().equipments" [columns]="equipmentsColumns"
                            [config]="tableConfig" dataKey="workName" [customTemplates]="equipmentsCustomTemplates" />
                    </div>
                </div>


                <div class="flex flex-col gap-4">
                    <h4 class="text-sm font-semibold ml-1">Stabilization Work Costs</h4>

                    <div>
                        <div class="flex justify-between items-center mb-2 ml-1">
                            <h5 class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Materials</h5>
                            <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'"
                                variant="outlined" severity="contrast" pTooltip="Expand" tooltipPosition="top"
                                (clicked)="openExpandDialog('stabilizationMaterials')">
                            </app-button>
                        </div>
                        <app-data-table [data]="stabilizationWorkCostFlat().materials" [columns]="materialsColumns"
                            [config]="materialsTableConfig" dataKey="workName"
                            [customTemplates]="materialsCustomTemplates" />
                    </div>

                    <div>
                        <div class="flex justify-between items-center mb-2 ml-1">
                            <h5 class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Labour</h5>
                            <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'"
                                variant="outlined" severity="contrast" pTooltip="Expand" tooltipPosition="top"
                                (clicked)="openExpandDialog('stabilizationLabour')">
                            </app-button>
                        </div>
                        <app-data-table [data]="stabilizationWorkCostFlat().labours" [columns]="laboursColumns"
                            [config]="tableConfig" dataKey="workName" [customTemplates]="laboursCustomTemplates" />
                    </div>

                    <div>
                        <div class="flex justify-between items-center mb-2 ml-1">
                            <h5 class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Equipment</h5>
                            <app-button [icon]="'maximize-2'" [iconSource]="'lucide'" [size]="'default'"
                                variant="outlined" severity="contrast" pTooltip="Expand" tooltipPosition="top"
                                (clicked)="openExpandDialog('stabilizationEquipment')">
                            </app-button>
                        </div>
                        <app-data-table [data]="stabilizationWorkCostFlat().equipments" [columns]="equipmentsColumns"
                            [config]="tableConfig" dataKey="workName" [customTemplates]="equipmentsCustomTemplates" />
                    </div>
                </div>

            </div>
        </div>

    </div>
    }

</div>


<!-- ── Reusable vendor-field cell macro ─────────────────────────────────────── -->
<!-- Project Info: value column -->
<ng-template #valueCellTpl let-row>
    <div class="flex items-center gap-1.5 w-full min-w-0">
        <div
            class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg min-w-0 flex-1 overflow-x-auto scrollbar-thin">
            <span class="whitespace-nowrap">{{ row.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer shrink-0" (click)="openProjectInfoSourceClick(row)" />
    </div>
</ng-template>

<!-- Works: name -->
<ng-template #workNameCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.name?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.name?.source)" />
    </div>
</ng-template>

<!-- Works: description -->
<ng-template #descriptionCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.description?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.description?.source)" />
    </div>
</ng-template>

<!-- Works: production rate -->
<ng-template #productionRateCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.productionRate?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.productionRate?.source)" />
    </div>
</ng-template>

<!-- Works: production rate unit -->
<ng-template #productionRateUnitCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.productionRateUnit?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.productionRateUnit?.source)" />
    </div>
</ng-template>

<!-- Cost tables: work name -->
<ng-template #workCostNameCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.workName?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.workName?.source)" />
    </div>
</ng-template>

<!-- Materials: material -->
<ng-template #materialCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.material?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.material?.source)" />
    </div>
</ng-template>

<!-- Materials: waste factor -->
<ng-template #wasteFactorCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.wasteFactor?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.wasteFactor?.source)" />
    </div>
</ng-template>

<!-- Materials: unit weight -->
<ng-template #unitWeightCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.unitWeight?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.unitWeight?.source)" />
    </div>
</ng-template>

<!-- Materials: unit cost -->
<ng-template #unitCostCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.unitCost?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.unitCost?.source)" />
    </div>
</ng-template>

<!-- Labour: labour -->
<ng-template #labourCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.labour?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.labour?.source)" />
    </div>
</ng-template>

<!-- Equipment: equipment -->
<ng-template #equipmentCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.equipment?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.equipment?.source)" />
    </div>
</ng-template>

<!-- Shared: unit cost per hr -->
<ng-template #unitCostPerHrCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.unitCostPerHr?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.unitCostPerHr?.source)" />
    </div>
</ng-template>

<!-- Shared: tax/OT % -->
<ng-template #taxOtPercentCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.taxOtPercent?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.taxOtPercent?.source)" />
    </div>
</ng-template>

<!-- Shared: quantity -->
<ng-template #quantityCellTpl let-row>
    <div class="flex items-center gap-1.5">
        <div class="flex items-center px-2 py-2 min-h-[2.25rem] border border-gray-200 rounded-lg flex-1">
            <span>{{ row.quantity?.value }}</span>
        </div>
        <app-icon [type]="'external-link'" [source]="'lucide'" [size]="'sm'" pTooltip="Source" tooltipPosition="top"
            class="cursor-pointer" (click)="openCellSource(row.quantity?.source)" />
    </div>
</ng-template>

<ng-template #truncateCellTpl let-row let-field="field">
    <span class="block truncate max-w-[6.25rem] items-center " [pTooltip]="row[field] != null ? ('' + row[field]) : ''"
        tooltipPosition="top">
        {{ row[field] ?? '—' }}
    </span>
</ng-template>


<!-- Legacy source cell (kept for any remaining usage) -->
<ng-template #sourceCellTpl let-row>
    @if(row.source?.sourceType){
    <app-button [icon]="'external-link'" [iconSource]="'lucide'" variant="ghost" severity="contrast" pTooltip="Source"
        tooltipPosition="top" (clicked)="openCellSource(row.source)"></app-button>
    }@else {
    <span>—</span>
    }
</ng-template>

<app-dialog [visible]="expandedTable === 'projectInfo'" (closed)="closeExpandDialog()" title="Project Information"
    class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="projectInfoRows()" [columns]="projectInfoColumns" [config]="tableConfig"
                dataKey="property" [customTemplates]="projectInfoCustomTemplates" [showScrollBar]="true" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'generalWorks'" (closed)="closeExpandDialog()" title="General Works"
    class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="generalWorks()" [columns]="worksColumns" [config]="tableConfig" dataKey="name"
                [customTemplates]="worksCustomTemplates" [showScrollBar]="true" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'stabilizationWorks'" (closed)="closeExpandDialog()"
    title="Stabilization Works" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="stabilizationWorks()" [columns]="worksColumns" [config]="tableConfig" dataKey="name"
                [customTemplates]="worksCustomTemplates" [showScrollBar]="true" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'generalMaterials'" (closed)="closeExpandDialog()"
    title="General Work Costs — Materials" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="generalWorkCostFlat().materials" [columns]="materialsColumns"
                [config]="materialsTableConfig" dataKey="workName" [showScrollBar]="true"
                [customTemplates]="materialsCustomTemplates" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'generalLabour'" (closed)="closeExpandDialog()"
    title="General Work Costs — Labour" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="generalWorkCostFlat().labours" [columns]="laboursColumns" [config]="tableConfig"
                dataKey="workName" [showScrollBar]="true" [customTemplates]="laboursCustomTemplates" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'generalEquipment'" (closed)="closeExpandDialog()"
    title="General Work Costs — Equipment" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="generalWorkCostFlat().equipments" [columns]="equipmentsColumns"
                [config]="tableConfig" dataKey="workName" [showScrollBar]="true"
                [customTemplates]="equipmentsCustomTemplates" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'stabilizationMaterials'" (closed)="closeExpandDialog()"
    title="Stabilization Work Costs — Materials" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="stabilizationWorkCostFlat().materials" [columns]="materialsColumns"
                [config]="materialsTableConfig" dataKey="workName" [showScrollBar]="true"
                [customTemplates]="materialsCustomTemplates" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'stabilizationLabour'" (closed)="closeExpandDialog()"
    title="Stabilization Work Costs — Labour" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="stabilizationWorkCostFlat().labours" [columns]="laboursColumns"
                [config]="tableConfig" dataKey="workName" [showScrollBar]="true"
                [customTemplates]="laboursCustomTemplates" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="expandedTable === 'stabilizationEquipment'" (closed)="closeExpandDialog()"
    title="Stabilization Work Costs — Equipment" class="max-w-[90vw] w-[90vw]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 max-h-[75vh] overflow-y-auto scrollbar-thin">
            <app-data-table [data]="stabilizationWorkCostFlat().equipments" [columns]="equipmentsColumns"
                [config]="tableConfig" dataKey="workName" [showScrollBar]="true"
                [customTemplates]="equipmentsCustomTemplates" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="sourceDialogVisible" title="Source" class="w-[600px] max-w-[95vw]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-5 px-6 py-4 pb-6">
            <div class="flex flex-col gap-2">
                <span class="font-semibold text-gray-800">Reason</span>
                <div class="border border-orange-400 rounded-lg px-4 py-3 text-sm text-gray-700 leading-relaxed">
                    {{ selectedSource?.reason }}
                </div>
            </div>
            @if (selectedSource?.sources?.length) {
            @let total = selectedSource!.sources!.length;
            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <span class="font-semibold text-gray-800">Source</span>
                    <div class="flex items-center gap-1">
                        <button type="button" (click)="navigateSource(-1)" [disabled]="aiSourceIndex === 0"
                            class="w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
                            <app-icon type="chevron-left" source="lucide" [size]="'sm'" />
                        </button>
                        <button type="button" (click)="navigateSource(1)" [disabled]="aiSourceIndex === total - 1"
                            class="w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
                            <app-icon type="chevron-right" source="lucide" [size]="'sm'" />
                        </button>
                    </div>
                </div>
                @if (selectedSource?.sourceType === 'WEB_SEARCH') {
                @let url = selectedSource!.sources![aiSourceIndex];
                @let favicon = getFavicon(url);
                <div class="border border-zinc-200 rounded-lg shadow-sm">
                    <div class="flex gap-3 p-4">
                        @if (favicon) {
                        <img [src]="favicon" alt="" class="w-5 h-5 rounded mt-0.5 shrink-0"
                            (error)="onFaviconError($event)" />
                        }
                        <div class="flex flex-col gap-2 min-w-0">
                            <div class="flex items-center">
                                <span
                                    class="text-xs px-2 py-0.5 bg-zinc-50 border border-zinc-200 rounded-lg flex items-center gap-1.5">
                                    <app-icon type="globe" source="lucide" size="sm" class="h-3 w-3"></app-icon>
                                    Web
                                </span>
                            </div>
                            <a [href]="url" target="_blank" rel="noopener noreferrer"
                                class="text-sm font-medium text-blue-600 hover:underline line-clamp-1 block break-all">
                                {{ url }}
                            </a>
                            <div class="text-xs text-zinc-500 flex items-center gap-1.5">
                                <app-icon type="globe" source="lucide" size="sm" class="h-3 w-3 shrink-0"></app-icon>
                                {{ cleanUrl(url) }}
                            </div>
                        </div>
                    </div>
                </div>
                } @else {
                <div class="border border-gray-200 rounded-lg p-4 text-sm text-gray-700 leading-relaxed">
                    <p class="font-semibold text-gray-500 mb-2">Source {{ aiSourceIndex + 1 }}</p>
                    <p>{{ selectedSource!.sources![aiSourceIndex] }}</p>
                </div>
                }
            </div>
            }
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="analysisExcelDialogVisible" title="Analysis Excel"
    class="max-w-[96rem] w-[92vw] analysis-excel-preview-dialog" (closed)="onAnalysisExcelDialogHide()">
    <ng-template #bodyTemplate>
        @let analysisExcelPreview = analysisExcelPreviewFile();
        @let analysisExcelEditor = analysisExcelEditorConfig();
        <div class="h-[78vh] bg-white overflow-hidden">
            @if (analysisExcelEditor && analysisExcelPreview) {
            <app-only-office-doc-editor class="block h-full w-full" [contractId]="analysisExcelPreview._id"
                [configData]="analysisExcelEditor" [editorId]="'analysis_excel_vendor_' + analysisExcelPreview._id"
                (documentReady)="onAnalysisExcelReady()"></app-only-office-doc-editor>
            } @else {
            <div class="flex h-full items-center justify-center px-6 text-sm text-gray-500">
                Analysis excel is not available.
            </div>
            }
        </div>
    </ng-template>
</app-dialog>

<!-- Project Info Edit Dialog -->
<app-dialog [(visible)]="projectInfoEditVisible" title="Project Information">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-5 p-3">
            <!-- Project Area -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1.5">
                    <label class="text-sm font-semibold text-gray-900">Project Area <span
                            class="text-red-500">*</span></label>
                    <span class="flex items-center justify-center cursor-help" [pTooltip]="PROJECT_AREA_TOOLTIP"
                        tooltipPosition="top">
                        <app-icon type="info" source="lucide" size="sm" class="text-gray-400"></app-icon>
                    </span>
                </div>
                <input pInputText type="number" [(ngModel)]="editProjectArea" min="0"
                    placeholder="Enter project area (SY)" [disabled]="projectInfoViewOnly"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
            </div>
            <!-- Shift Hours per Day -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1.5">
                    <label class="text-sm font-semibold text-gray-900">Shift Hours per Day <span
                            class="text-red-500">*</span></label>
                    <span class="flex items-center justify-center cursor-help" [pTooltip]="SHIFT_HOURS_TOOLTIP"
                        tooltipPosition="top">
                        <app-icon type="info" source="lucide" size="sm" class="text-gray-400"></app-icon>
                    </span>
                </div>
                <input pInputText type="number" [(ngModel)]="editShiftHoursPerDay" min="0"
                    placeholder="Enter shift hours per day" [disabled]="projectInfoViewOnly"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
            </div>
            <!-- Theoretical Budget -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1.5">
                    <label class="text-sm font-semibold text-gray-900">Theoretical Budget ($) <span
                            class="text-red-500">*</span></label>
                    <span class="flex items-center justify-center cursor-help" [pTooltip]="THEORETICAL_BUDGET_TOOLTIP"
                        tooltipPosition="top">
                        <app-icon type="info" source="lucide" size="sm" class="text-gray-400"></app-icon>
                    </span>
                </div>
                <input pInputText type="number" [(ngModel)]="editTheoreticalBudget" min="0"
                    placeholder="Enter theoretical budget" [disabled]="projectInfoViewOnly"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
            </div>
            <!-- Theoretical Schedule -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1.5">
                    <label class="text-sm font-semibold text-gray-900">Theoretical Schedule (Workdays) <span
                            class="text-red-500">*</span></label>
                    <span class="flex items-center justify-center cursor-help" [pTooltip]="THEORETICAL_SCHEDULE_TOOLTIP"
                        tooltipPosition="top">
                        <app-icon type="info" source="lucide" size="sm" class="text-gray-400"></app-icon>
                    </span>
                </div>
                <input pInputText type="number" [(ngModel)]="editTheoreticalScheduleWorkdays" min="0"
                    placeholder="Enter theoretical schedule (workdays)" [disabled]="projectInfoViewOnly"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
            </div>
            <!-- Project Location -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1.5">
                    <label class="text-sm font-semibold text-gray-900">Project Location</label>
                    <span class="flex items-center justify-center cursor-help" [pTooltip]="PROJECT_LOCATION_TOOLTIP"
                        tooltipPosition="top">
                        <app-icon type="info" source="lucide" size="sm" class="text-gray-400"></app-icon>
                    </span>
                </div>
                <input pInputText type="text" [(ngModel)]="editProjectLocation" placeholder="Enter project location"
                    [disabled]="projectInfoViewOnly"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-row justify-end gap-2 p-3">
            @if (projectInfoViewOnly) {
            <app-button variant="outlined" (clicked)="projectInfoEditVisible = false">Close</app-button>
            } @else {
            <app-button variant="outlined" (clicked)="projectInfoEditVisible = false">Cancel</app-button>
            <app-button severity="primary" [disabled]="!isEditProjectInfoValid" [loading]="savingProjectInfo()"
                (clicked)="onProjectInfoSave()">Save</app-button>
            }
        </div>
    </ng-template>
</app-dialog>